import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React from 'react';
import { styled } from 'linaria/react';
import { TabInner } from './ProductTabs';
import { SVG } from '../../../../assets/SVG';
import { LoadableProductListCard } from '../../../CategoryPage/ProductGridWindow';
import { DynamicCategoryRenderer } from '../../../ContentEditor/DynamicCategoryRenderer/DynamicCategoryRenderer';
import { DownloadableFiles } from './DownloadableFiles';

const ProductSection = styled('div')`
  color: #333;
  font-size: 14px;
  line-height: 120%;
  width: 100%;
  border-bottom: 1px solid #f0f0f0;

  .brandheader-textitem {
    padding: 0;
  }

  h3 {
    font-size: 14px;
    font-weight: 700;
    padding: 20px 0 14px 0;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
  }
`;

const AccordionWrapper = styled('span')`
  padding: 0 20px;
  display: block;
  margin: 20px 0;
`;
const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
  svg {
    transition: all, 0.2s ease;
    &.down {
      transform: rotate(-90deg);
    }
    &.up {
      transform: rotate(0);
    }
  }
`;

const SpecificationsWrapper = styled('div')`
  display: flex;
  :nth-of-type(odd) {
    background: #f7f7f7;
  }

  .title {
    font-weight: 700;
    text-transform: uppercase;
    min-width: 20%;
    font-size: 12px;
    margin: 5px 0 1px 10px;
    letter-spacing: 1.1px;
  }

  .text {
    font-size: 12px;
    margin: 5px 0 1px 10px;
    letter-spacing: 1.1px;
  }
`;

const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>
    {isOpen ? (
      <SVG name="AngleDown" className="down up" />
    ) : (
      <SVG name="AngleDown" className="down" />
    )}
  </IndicatorIcon>
);

const ProductInfoAccordion = ({
  product,
  setRemoteOpenIndex,
  remoteOpenIndex,
  brandsCategoryResult
}) => {
  const excludedCustomFields = ['files', 'Variants'];

  const filteredCustomFields = product?.customFields?.filter(
    customField => !excludedCustomFields.includes(customField.key)
  );

  const relatedProducts = product?.relatedProducts;
  const brand = product?.customFields?.filter(
    customField => customField?.key === 'Varumarke'
  );
  const files = product?.customFields?.filter(
    customField => customField.key === 'files'
  );
  const specifications = filteredCustomFields;

  const hasDescription = !!product?.description;

  const hasSpecifications = specifications?.length > 0;
  const hasRelatedProducts = product?.relatedProducts?.length > 0;
  const hasFiles = files?.length > 0;
  const hasBrand = !!brand;

  const brandInformationData = brandsCategoryResult?.find(
    subcat =>
      subcat?.name?.toLowerCase() === brand?.[0]?.stringValue?.toLowerCase()
  );

  //ad has files

  return (
    <Accordion single initialOpenIndexes={[remoteOpenIndex ?? 0]}>
      {({ openIndexes, handleClick, AccordionContent }) => (
        <AccordionWrapper>
          {hasDescription && (
            <ProductSection>
              <h3 onClick={() => handleClick(0)}>
                <span>{t('Product description')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(0)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(0)}>
                <TabInner>
                  {product?.description && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: product?.description
                      }}
                    />
                  )}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )}

          {hasSpecifications && (
            <ProductSection>
              <h3 onClick={() => handleClick(1)}>
                <span>{t('Specifications')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(1)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(1)}>
                <TabInner>
                  {specifications?.map((specification, index) => {
                    return (
                      <SpecificationsWrapper key={index}>
                        <p className="title">{specification?.title}</p>
                        <p className="text"> {specification?.stringValue}</p>
                      </SpecificationsWrapper>
                    );
                  })}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )}

          {hasRelatedProducts && (
            <ProductSection>
              <h3 onClick={() => handleClick(2)}>
                <span>{t('Accessories')}</span>
                <AccordionIndicator isOpen={openIndexes.includes(2)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(2)}>
                <TabInner>
                  {relatedProducts?.map((product, index) => {
                    return (
                      <LoadableProductListCard
                        key={product?.articleNumber}
                        product={product}
                        as="div"
                      />
                    );
                  })}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )}

          {/* {hasFiles && (
            <ProductSection>
              <h3 onClick={() => handleClick(3)}>
                {t('Attached files')}
                <AccordionIndicator isOpen={openIndexes.includes(3)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(3)}>
                <TabInner>
                  <DownloadableFiles files={files} />
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )} */}

          {/* {hasBrand && (
            <ProductSection>
              <h3 onClick={() => handleClick(4)}>
                {t('About ')}
                {brand?.[0]?.stringValue}
                <AccordionIndicator isOpen={openIndexes.includes(4)} />
              </h3>
              <AccordionContent isOpen={openIndexes.includes(4)}>
                <TabInner>
                  {brandInformationData?.id && (
                    <div>
                      <DynamicCategoryRenderer
                        categoryId={brandInformationData?.id}
                      />
                    </div>
                  )}
                </TabInner>
              </AccordionContent>
            </ProductSection>
          )} */}
        </AccordionWrapper>
      )}
    </Accordion>
  );
};

export default ProductInfoAccordion;
